module.exports = __webpack_public_path__ + "static/img/code.b5a4aa86.jpg";